import { BodyText, Icon, IconSet } from '@postscript/components';

import React from 'react';
import styled from 'styled-components';

interface LoaderProps {
  children?: React.ReactNode;
  size?: 'x-small' | 'small' | 'medium' | 'large';
}

const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  color: var(--text-color);
`;

const Spinner = styled(Icon)`
  animation: rotate 2s linear infinite;

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Loader = ({
  children,
  size = 'medium',
  ...props
}: LoaderProps): JSX.Element => (
  <LoaderContainer {...props}>
    <Spinner
      color="inherit"
      component={IconSet.Rotate2}
      size={size === 'x-small' ? 'small' : size}
    />
    {children && (
      <BodyText color="inherit" size={size}>
        {children}
      </BodyText>
    )}
  </LoaderContainer>
);

export default Loader;
